import React from "react";
import {
    Container,
    TextContainer,
    AddCta,
    RemoveCta,
    PrimaryText,
    CouponApppliedText,
    SecondaryText
} from "./styles";
import ImageContainer from "@components/imageContainer";


const Coupon = ({
    appliedCouponCode,
    coupon,
    addCoupon,
    removeCoupon,
    couponDiscountAmount,
    couponTickSrc,
    couponIconSrc,
    couponAppliedText,
    availableForSelectedPlan,
    removeCta,
    applyCta
}) => {
    const { coupon_value, coupon_type, code, coupon_display_name } = coupon;
    const isCouponApplied = appliedCouponCode === code;
    return (
        <Container>
            <div style={{ minWidth: "32px", minHeight: "32px" }}>
                {isCouponApplied ? <ImageContainer imgSrc={couponTickSrc} width={32}
                    height={32} /> : <ImageContainer imgSrc={couponIconSrc} width={32}
                        height={32} />}

            </div>
            <TextContainer>
                <PrimaryText
                    style={{ fontSize: "14px", fontWeight: 500, lineHeight: "20px" }}
                >
                    {coupon_display_name ?? code} |{" "}
                    {coupon_type === "percent"
                        ? `${coupon_value}% off`
                        : `₹${coupon_value} off`}
                </PrimaryText>
                {isCouponApplied ? (
                    <CouponApppliedText>
                        {couponAppliedText}
                    </CouponApppliedText>
                ) : (
                    <SecondaryText
                        style={{ fontSize: "12px", fontWeight: 400, lineHeight: "16px" }}
                    >
                        {availableForSelectedPlan}
                    </SecondaryText>
                )}
            </TextContainer>
            {isCouponApplied ? (
                <RemoveCta
                    onClick={() => {
                        removeCoupon();
                    }}
                >
                    {removeCta}
                </RemoveCta>
            ) : (
                <AddCta
                    onClick={() => {
                        addCoupon();
                    }}
                >
                    {applyCta}
                </AddCta>
            )}
        </Container>
    );
};

export default Coupon;
